
const state = {
  volunteerList:[],
  InfoStatus:[],
}

const mutations = {
  getVolunteerList(state, data) {
    state.volunteerList = data || ''
  },
  getInfoStatus(state, data) {
    state.InfoStatus = data || ''
  }
}

export default {
  state,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/volunteer.js